import { Regulator } from 'types/regulator';

import * as utils from '../utils';

export const getAll = () =>
    utils.get('/regulators') as Promise<{ regulators: Regulator[] }>;
export const get = ({ code }: { code: string }) =>
    utils.get(`/regulators/${code}`) as Promise<Regulator>;
